import React from "react";
import DataGrid from './data-grid';
import { Tooltip } from '@progress/kendo-react-tooltip';
import format from "../functions/format";
import Trend from "./trend";
export default class ActivityPagesGrid extends React.Component {
  render() {
    var data = this.props.data;
    var domain = this.props.domain;
    var comparison = this.props.comparison;
    var columns = [{
      field: 'url',
      title: 'Url',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        var url = row.url;
        if (!url.includes(domain)) url = domain + url;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Tooltip, {
          anchorElement: "target",
          position: "top"
        }, /*#__PURE__*/React.createElement("a", {
          href: url,
          target: "_blank",
          title: row.url
        }, row.url)));
      }
    }, {
      field: 'views',
      title: 'Views',
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x.productId === row.productId);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, format(row.views, '-', 0, '')), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.views,
          data: row.views
        })));
      }
    }, {
      field: 'uniqueUsers',
      title: 'Users',
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x.productId === row.productId);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, format(row.uniqueUsers, '-', 0, '')), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.uniqueUsers,
          data: row.uniqueUsers
        })));
      }
    }, {
      field: 'sessions',
      title: 'Sessions',
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x.productId === row.productId);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, format(row.sessions, '-', 0, '')), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.sessions,
          data: row.sessions
        })));
      }
    }, {
      field: 'avgTimeSpan',
      title: 'Avg. Time Span',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, format(row.avgTimeSpan, '-', 0, '')));
      }
    }];
    return /*#__PURE__*/React.createElement(DataGrid, {
      data: data,
      columns: columns,
      pageSize: 10,
      pagination: this.props.pagination,
      onPageRequest: this.props.onPageRequest
    });
  }
}